import { AccountLockupFragment } from "@opensea/app-kit"
import { graphql } from "@opensea/graphql"

export const ProfileBioFragment = graphql(
  `
    fragment ProfileBio on Profile {
      imageUrl
      bio
      ...AccountLockup
    }
  `,
  [AccountLockupFragment],
)
